import { useNodeService } from "@fero/hooks";
import type { salePricesContract } from "@fero-shared/api-contracts";
import type { DataResponse } from "@ts-rest/react-query";
import { tradeSalesKeys } from "../../query-keys";

interface GetPurchaserSavedProductPricesQueryParams {
  organisationId: string;
  purchaserId: string;
  onSuccess?: (
    data: DataResponse<typeof salePricesContract.getPurchaserProductSalePrices>,
  ) => void;
}

export const useGetPurchaserSavedProductPricesQuery = ({
  organisationId,
  purchaserId,
  onSuccess,
}: GetPurchaserSavedProductPricesQueryParams) => {
  const nodeService = useNodeService();
  return nodeService.getPurchaserProductSalePrices.useQuery(
    tradeSalesKeys.purchaserProductPrices(organisationId, purchaserId),
    { query: { organisationId, purchaserId } },
    {
      onSuccess,
    },
  );
};
